export enum FundingSourceEnum {
  'VPC' = 1,
  'VPS',
  'ESG',
  'FMP',
  'CT',
}
